import { MutationCache } from "@tanstack/react-query";

import { toast } from "../ui/toast";
import { translateKey } from "../../i18n";

export function createAdminMutationCache(isAdmin = () => window.location.pathname.startsWith("/admin")) {
  return new MutationCache({
    onError: (error, _variables, _result, mutation) => {
      // 已有定制反馈的操作自行更新其 loading Toast，避免重复通知。
      if (isAdmin() && !mutation.options.onError && !mutation.options.meta?.toastHandled) {
        toast.error(translateKey("adminOperations.failed"), { description: error.message || translateKey("adminOperations.tryAgain") });
      }
    },
  });
}
